const KpiStatusColors = {
  Gray: "default",
  Green: "success",
  Yellow: "warning",
  Red: "error",
};

export default KpiStatusColors;
